import { render, staticRenderFns } from "./PrimeCostsReport.vue?vue&type=template&id=756d7252&"
import script from "./PrimeCostsReport.vue?vue&type=script&lang=ts&"
export * from "./PrimeCostsReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports